import * as React from "react";
import { observer } from "mobx-react";
import { ILocalization } from "../../../models/localization";
import SeekerStore from "../../../stores/seekerStore";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui/Paper";
import { ProfileViewState } from "../../../models/enums";
import ExperienceToSkills from "../experienceMapping";
import SkillsToExperience from "../skillMapping";
import * as s from "./editor.css";

@observer
export default class EditorContainer extends React.Component<{ store: SeekerStore }, {}> {

  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return (
      <Paper elevation={1} className={s.box} >
        <div className={s.displayBox}>
          {this.props.store.profileStore.profileViewMode === ProfileViewState.SkillsView && <SkillsToExperience store={this.props.store}  />}
          {this.props.store.profileStore.profileViewMode === ProfileViewState.ExperienceView && <ExperienceToSkills store={this.props.store} />}
        </div>
      </Paper>);
  }
}


// WEBPACK FOOTER //
// ./src/components/profile/editorContainer/index.tsx